// Eventos de DataLayer para GTM e Google Ads
// Usado para remarketing e tracking de abandono

// dataLayer type já declarado em src/lib/tracking.ts

// Nomes dos steps para tracking
const STEP_NAMES: Record<number, string> = {
  0: 'intro',
  1: 'name',
  2: 'contact',
  3: 'profile',
  4: 'situation',
  5: 'objective',
  6: 'features',
  7: 'branding',
  8: 'content',
  9: 'urgency',
  10: 'details',
  11: 'lgpd',
  12: 'submitting',
  13: 'success'
}

// Push evento de step completado
export function pushStepEvent(step: number, formData?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.dataLayer) return

  const stepName = STEP_NAMES[step] || `step_${step}`

  window.dataLayer.push({
    event: 'form_step_completed',
    form_step: step,
    form_step_name: stepName,
    timestamp: new Date().toISOString(),
    // Dados contextuais baseados no step
    ...(step === 2 && formData && {
      has_email: !!formData.email,
      has_whatsapp: !!formData.whatsapp
    }),
    ...(step === 5 && formData && {
      objective: formData.objective
    }),
    ...(step === 9 && formData && {
      urgency: formData.urgency
    }),
    ...(step === 10 && formData && {
      project_type: formData.projectType
    })
  })
}

// Push evento de abandono
export function pushAbandonmentEvent(
  currentStep: number,
  timeSpentMs: number,
  formData?: Record<string, unknown>
) {
  if (typeof window === 'undefined' || !window.dataLayer) return

  const stepName = STEP_NAMES[currentStep] || `step_${currentStep}`
  const hasContactInfo = !!(formData?.email || formData?.whatsapp)
  const fieldsFilledCount = formData
    ? Object.keys(formData).filter(k => formData[k] != null && formData[k] !== '').length
    : 0

  window.dataLayer.push({
    event: 'form_abandoned',
    abandoned_at_step: currentStep,
    abandoned_at_step_name: stepName,
    time_spent_seconds: Math.round(timeSpentMs / 1000),
    has_contact_info: hasContactInfo,
    fields_filled: fieldsFilledCount,
    timestamp: new Date().toISOString()
  })
}

// Push evento de início de formulário
export function pushFormStartEvent() {
  if (typeof window === 'undefined' || !window.dataLayer) return

  window.dataLayer.push({
    event: 'form_started',
    timestamp: new Date().toISOString()
  })
}

// Push evento de formulário completo
export function pushFormCompleteEvent(formData?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !window.dataLayer) return

  window.dataLayer.push({
    event: 'form_completed',
    project_type: formData?.projectType,
    objective: formData?.objective,
    urgency: formData?.urgency,
    timestamp: new Date().toISOString()
  })
}

// Push evento de recuperação (voltou ao form)
export function pushRecoveryEvent(sessionId: string, returnedToStep: number) {
  if (typeof window === 'undefined' || !window.dataLayer) return

  window.dataLayer.push({
    event: 'form_recovered',
    session_id: sessionId,
    returned_to_step: returnedToStep,
    timestamp: new Date().toISOString()
  })
}

// Push evento de fase completada (gamificação)
export function pushPhaseCompleteEvent(phaseName: string, phaseIndex: number) {
  if (typeof window === 'undefined' || !window.dataLayer) return

  window.dataLayer.push({
    event: 'form_phase_completed',
    phase_name: phaseName,
    phase_index: phaseIndex,
    timestamp: new Date().toISOString()
  })
}
